import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// redux
import { useSelector, toggleMenu } from 'store'
import { useDispatch } from 'react-redux';

// svg
import { ReactComponent as Logo } from 'asset/img/header/logo.svg';

// function
import MoveWithMarketo from 'function/MoveWithMarketo';

// scss
import './Header.scss';

type Props = {}

const Header: React.FC<Props> = (props) => {

  // state
  const [isOpenSns, setIsOpenSns] = useState(false);

  // selector
  const { isMenuOpen } = useSelector((state) => {
    return {
      isMenuOpen: state.isMenuOpen,  // ここでコード補完がきちんと効く
    };
  });

  // dispatch
  const dispatch = useDispatch();

  // history
  const history = useHistory();

  const handleClickMenu = (e:React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(toggleMenu());
  }

  const handleToggleSns = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>)=>{
    e.preventDefault();
    setIsOpenSns(!isOpenSns);
  }

  return (
    <header id="Header">
      <div className="headerWrapper">
        <div className="headerLeft">
          <ul>
            <li className="logo"><Logo /></li>
            <li className="siteName"><Link to="/digital/fair2021/showroom/index.html?nointro=1">TOKYO SHOWROOM</Link></li>
          </ul>
        </div>
        <div className="headerRight">
          <ul>
            {/* <li className="sns">
              <a href="/" className="shareLink" onClick={(e)=>{handleToggleSns(e)}}>SHARE</a>
              {isOpenSns &&
                <div className="snsLinkGroup">
                  <ul>
                    <li className="twitter"><a href="https://twitter.com/share?text=%E3%82%B3%E3%82%AF%E3%83%A8%E5%93%81%E5%B7%9D%E3%82%B7%E3%83%A7%E3%83%BC%E3%83%AB%E3%83%BC%E3%83%A0%0D%0A&url=https://fair2021.kokuyo-furniture.co.jp/digital/fair2021/showroom/index.html" rel="noreferrer" target="_blank">Twitter</a></li>
                    <li className="facebook"><a href="http://www.facebook.com/share.php?u=https://fair2021.kokuyo-furniture.co.jp/digital/fair2021/showroom/index.html" rel="noreferrer" target="_blank">Facebook</a></li> */}
                    {/* <li className="instagram"><a href="https://www.instagram.com/kokuyo_fn/" rel="noreferrer" target="_blank">Instagram</a></li> */}
                  {/* </ul>
                </div>
              }
            </li> */}
            <li className="menuWrapper"><a href="/"
              className={ isMenuOpen ? 'menu isMenuOpen' : 'menu' }
              onClick={handleClickMenu}
            >MENU</a></li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
